import React from 'react'
import Layout from '../../Layout'
import ColorListContainer from '../../../../Components/VehicleContainer/ColorListContainer/ColorListContainer'

const ColorList = () => {
  return (
    <Layout>
        <ColorListContainer/>
    </Layout>
  )
}

export default ColorList